import i18next from 'i18next';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_NEXT_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';

import GroupsAndStoresSelectionModal from '@commons/Modals/GroupsAndStoresSelectionModal';

const MODAL_WIDTH = '600px';
const MODAL_CONTENT_PADDING = '24px';

/**
 * Modal opened before the file picker, to restrict the central kitchens on which the products of
 * the batch creation file will be created.
 */
export const getImportCentralKitchenProductsScopeModalConfig = ({
  groups,
  selectedGroups,
  setSelectedGroups,
  stores,
  selectedStores,
  setSelectedStores,
  handleNext,
  handleCloseCleanUp,
}) => ({
  type: 'action',
  width: MODAL_WIDTH,
  height: 'auto',
  icon: '/images/inpulse/store-black-small.svg',
  title: i18next.t('ADMIN.PRODUCTS.IMPORT_CENTRAL_KITCHEN_SCOPE_MODAL_TITLE'),
  customPadding: MODAL_CONTENT_PADDING,
  applyOverflow: false,
  isLoading: false,
  handleCloseCleanUp,
  component: GroupsAndStoresSelectionModal,
  data: {
    introText: i18next.t('ADMIN.PRODUCTS.IMPORT_CENTRAL_KITCHEN_SCOPE_MODAL_INTRO'),
    storesLabel: i18next.t('ADMIN.PRODUCTS.IMPORT_CENTRAL_KITCHEN_SCOPE_MODAL_STORES_LABEL'),
    groups,
    selectedGroups,
    setSelectedGroups,
    stores,
    selectedStores,
    setSelectedStores,
  },
  actions: [
    GENERIC_MODAL_CANCEL_BUTTON(),
    {
      ...GENERIC_MODAL_NEXT_BUTTON(),
      preventClosing: true,
      isDisabled: !selectedStores.length,
      handleClick: handleNext,
    },
  ],
});
